import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import {
  getAvailableAnswerOptionsListsExist,
  getFormQuestionAttributeUseSavedOptionsList,
} from "reduxSlices/formBuilderSlice"
import * as MultiSelectAttributes from "./MultiSelectAttributes"
import QuestionRequired from "./QuestionRequired"
import QuestionShowDescription from "./QuestionShowDescription"

const MultiSelectConfig = ({ sectionIndex, questionIndex }) => {
  const useSavedOptionsList = useSelector(
    getFormQuestionAttributeUseSavedOptionsList({ sectionIndex, questionIndex }),
  )
  const answerOptionsListsExist = useSelector(getAvailableAnswerOptionsListsExist)
  // Hide the toggle when there's nothing to select -- unless the question is already using a saved
  // list (e.g. the org's lists were removed after this question was configured), so it stays visible
  // to toggle back off.
  const showUseSavedOptionsList = answerOptionsListsExist || useSavedOptionsList

  return (
    <>
      <QuestionRequired
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
      <QuestionShowDescription
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
      {
        showUseSavedOptionsList && (
          <MultiSelectAttributes.UseSavedOptionsList
            sectionIndex={sectionIndex}
            questionIndex={questionIndex}
          />
        )
      }
      {
        useSavedOptionsList && (
          <MultiSelectAttributes.AnswerOptionsListSelect
            sectionIndex={sectionIndex}
            questionIndex={questionIndex}
          />
        )
      }
      <MultiSelectAttributes.DisplayAs
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
      <MultiSelectAttributes.ColumnCount
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
      <MultiSelectAttributes.DefaultAnswers
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
    </>
  )
}

MultiSelectConfig.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default MultiSelectConfig
